import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Phone, Menu as MenuIcon, X, ShoppingBag, ShieldCheck } from 'lucide-react';
import { useCart } from '../context/CartContext';

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { totalItems } = useCart();

  const scrollTo = (id) => {
    setOpen(false);
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
      }, 80);
      return;
    }
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header className="sticky top-0 z-50 bg-[#f4ead4]/90 backdrop-blur-md">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-5 flex items-center justify-between gap-4">
        <button onClick={() => scrollTo('top')} className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-[#2a1a0f] flex items-center justify-center">
            <span className="text-[#f4ead4] font-serif text-xl">B</span>
          </div>
          <span className="font-serif text-xl text-[#2a1a0f]">Bliss Coffee</span>
        </button>

        <nav className="hidden md:flex items-center gap-8">
          <button
            onClick={() => scrollTo('menu')}
            className="text-[#2a1a0f] text-[15px] hover:opacity-70 transition-opacity"
          >
            Menu
          </button>
          <Link
            to="/preorder"
            className="text-[#2a1a0f] text-[15px] hover:opacity-70 transition-opacity"
          >
            Preorder
          </Link>
          <button
            onClick={() => scrollTo('reviews')}
            className="text-[#2a1a0f] text-[15px] hover:opacity-70 transition-opacity"
          >
            Reviews
          </button>
          <button
            onClick={() => scrollTo('visit')}
            className="text-[#2a1a0f] text-[15px] hover:opacity-70 transition-opacity"
          >
            Visit
          </button>
          <Link
            to="/staff"
            className="inline-flex items-center gap-1.5 text-[#2a1a0f] text-[15px] hover:opacity-70 transition-opacity"
          >
            <ShieldCheck className="w-4 h-4" strokeWidth={1.8} />
            Staff
          </Link>
        </nav>

        <div className="flex items-center gap-3">
          {totalItems > 0 && (
            <Link
              to="/preorder"
              className="relative inline-flex items-center gap-2 bg-[#f4ead4] border border-[#2a1a0f]/15 text-[#2a1a0f] px-3.5 py-2 rounded-full hover:bg-[#ecdcbf] transition-colors"
            >
              <ShoppingBag className="w-4 h-4" strokeWidth={1.8} />
              <span className="text-[13px]">{totalItems}</span>
            </Link>
          )}
          <a
            href="tel:+12509927066"
            className="hidden md:inline-flex items-center gap-2 bg-[#2a1a0f] text-[#f4ead4] px-5 py-2.5 rounded-full hover:bg-[#3d2817] transition-colors"
          >
            <Phone className="w-4 h-4" strokeWidth={1.8} />
            <span className="text-[15px]">Call</span>
          </a>
          <button className="md:hidden text-[#2a1a0f]" onClick={() => setOpen(!open)}>
            {open ? <X className="w-6 h-6" /> : <MenuIcon className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-[#2a1a0f]/10 bg-[#f4ead4] px-6 py-4 flex flex-col gap-4">
          <button onClick={() => scrollTo('menu')} className="text-left text-[#2a1a0f]">
            Menu
          </button>
          <Link to="/preorder" onClick={() => setOpen(false)} className="text-left text-[#2a1a0f]">
            Preorder
          </Link>
          <button onClick={() => scrollTo('reviews')} className="text-left text-[#2a1a0f]">
            Reviews
          </button>
          <button onClick={() => scrollTo('visit')} className="text-left text-[#2a1a0f]">
            Visit
          </button>
          <Link to="/staff" onClick={() => setOpen(false)} className="text-left text-[#2a1a0f] inline-flex items-center gap-2">
            <ShieldCheck className="w-4 h-4" /> Staff
          </Link>
          <a
            href="tel:+12509927066"
            className="inline-flex items-center gap-2 bg-[#2a1a0f] text-[#f4ead4] px-5 py-2.5 rounded-full w-fit"
          >
            <Phone className="w-4 h-4" strokeWidth={1.8} /> Call
          </a>
        </div>
      )}
    </header>
  );
};

export default Navbar;
